import React, { useEffect, useState, useCallback } from 'react'
import styled from 'styled-components'
import Title from 'shared/components/Title'

import { IntercomPublic } from 'components/IntercomPublic'
import constants from 'config/constants'

const Table = styled.div`
  display: table;
  min-height: 100%;
  height: 100%;
  width: 100%;
  background-color: rgba(61, 169, 98, 1);
  color: #fff;
  padding: 0 5%;
`

const TableCell = styled.div`
  display: table-cell;
  vertical-align: middle;
`

const Wrapper = ({ children }) => (
  <Table>
    <TableCell>{children}</TableCell>
  </Table>
)

const Body = styled.div`
  .head-line {
    transition: color 0.2s linear;
    font-size: 48px;
    line-height: 60px;
    letter-spacing: -1px;
    margin-bottom: 5px;
  }

  .subheader {
    transition: color 0.2s linear;
    font-size: 36px;
    line-height: 46px;
    color: #fff;
  }

  hr {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.2);
    border: none;
    width: 250px;
    margin: 35px 0;
  }

  .context {
    transition: color 0.2s linear;
    font-size: 18px;
    line-height: 27px;
  }

  &.content-container {
    max-width: 800px;
  }
`

export function Maintenance({ location }) {
  const forceRender = useForceRender()

  const createIntercomInstance = useCallback(() => {
    var w = window
    // @ts-ignore
    var ic = w.Intercom
    if (typeof ic === 'function') {
      ic('reattach_activator')
      // @ts-ignore
      ic('update', w.intercomSettings)
    } else {
      var d = document
      var i = function () {
        i.c(arguments)
      }
      i.q = []
      i.c = function (args) {
        i.q.push(args)
      }
      // @ts-ignore
      w.Intercom = i

      // @ts-ignore
      // eslint-disable-next-line no-inner-declarations
      function l() {
        const { intercomAppID } = constants
        var s = d.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.onload = forceRender
        s.src = `https://widget.intercom.io/widget/${intercomAppID}`
        var x = d.getElementsByTagName('script')[0]
        x.parentNode.insertBefore(s, x)
      }

      l()
    }
  }, [forceRender])

  useEffect(() => {
    createIntercomInstance()
    // @ts-ignore
  }, [createIntercomInstance])
  return (
    <Wrapper>
      {window.Intercom && (
        <IntercomPublic
          path={location.pathname}
          appId="g9guvxdz"
          // @ts-ignore
          Intercom={window.Intercom}
        />
      )}
      <Title title="Maintenance" />

      <Body className="content-container">
        <div className="subheader primary-text-color">Scheduled maintenance is in progress.</div>
        <hr />
        <div className="flow-root" />
        <div className="context primary-text-color">
          <p>Simplesat surveys are available with limited functionality.</p>
          <p>
            <a
              target="_blank"
              rel="noreferrer"
              style={{ color: 'white', textDecoration: 'underline' }}
              href="https://status.simplesat.io/"
            >
              See full details.
            </a>
          </p>
        </div>
      </Body>
    </Wrapper>
  )
}

function useForceRender() {
  const [, setState] = useState(null)

  return () => setState({})
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Maintenance/index.js